(() => {
  'use strict';
  const configElement = document.getElementById('ml-config');
  if (!configElement || configElement.dataset.initialised) return;
  configElement.dataset.initialised = 'true';
  let config;
  try { config = JSON.parse(configElement.textContent); } catch { return; }
  const root = document.querySelector('.modulo-landing');
  const $ = selector => root.querySelector(selector);
  const $$ = selector => Array.from(root.querySelectorAll(selector));
  const copy = config.copy, params = new URLSearchParams(location.search);
  let range = 'Senza', finishIndex = 0, surface = config.surfaces[0];
  let selectionVersion = 0;
  const perBrand = Object.fromEntries(['Silestone', 'Dekton'].map(brand => [brand, config.surfaces.find(s => s.brand === brand)]));
  function validStyle(style) {
    if (!style || !config.ranges[style.range]) return false;
    range = style.range;
    const index = config.ranges[range].choices.findIndex(c => c[0] === style.finish && c[1] === style.colour);
    finishIndex = Math.max(0, index);
    return true;
  }
  try {
    if (config.kind === 'kitchen') validStyle(JSON.parse(localStorage.getItem('modulo-kitchen-autosave-v1'))?.state?.style);
    else surface = config.surfaces.find(s => s.id === JSON.parse(localStorage.getItem('modulo-worktops-v1'))?.surface) || surface;
  } catch {}
  if (config.kind === 'kitchen' && config.ranges[params.get('range')]) {
    validStyle({range: params.get('range'), finish: params.get('finish'), colour: params.get('colour')});
    selectionVersion++;
  }
  const entrySurface = config.surfaces.find(s => s.id === params.get('surface'));
  if (entrySurface) { surface = entrySurface; selectionVersion++; }
  perBrand[surface.brand] = surface;
  const safeTrack = (name, detail = {}) => {
    const event = {event: `modulo_${name}`, page_type: config.kind, ...detail};
    document.dispatchEvent(new CustomEvent('modulo:landing-event', {detail: event}));
    if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) (window.dataLayer ||= []).push(event);
  };
  const keepPreview = url => {
    for (const key of ['preview_theme_id', '_fd', 'pb']) if (params.has(key)) url.searchParams.set(key, params.get(key));
    return url;
  };
  function renderKitchen() {
    const selected = config.ranges[range], choice = selected.choices[finishIndex];
    const photo = $('#kitchen-looks > img');
    if (!photo) return;
    photo.src = choice[3];
    const sharedPhoto = selected.choices.filter(c => c[3] === choice[3]).length > 1;
    photo.alt = sharedPhoto ? `${range} two-tone range photograph showing gloss dove grey and white` : `${range} ${selected.label} · ${choice[2]}`;
    $('[data-kitchen-caption]').textContent = sharedPhoto ? `${range} · Two-tone range photograph · Selected: ${choice[2]}` : `${range} · ${selected.label} · ${choice[2]}`;
    $('[data-finish-name]').textContent = choice[2];
    $('[data-selected-finish]').textContent = choice[2];
    const sample = $('[data-kitchen-sample]');
    sample.style.setProperty('--colour', choice[4]); sample.dataset.styleRange = range; sample.dataset.styleFinish = choice[0];
    $('[data-range-description]').textContent = selected.description;
    const unavailable = range === 'Senza' && choice[0] === 'Gloss' && choice[1] === 'White';
    let notice = $('[data-finish-notice]');
    if (!notice) {
      notice = document.createElement('div'); notice.className = 'ml-finish-notice'; notice.dataset.finishNotice = 'true'; notice.setAttribute('role', 'status');
      notice.append(document.createTextNode('This finish is available to preview. Please ask us to confirm its product list and price before ordering. '));
      const link = document.createElement('a'); link.href = keepPreview(new URL((config.root || '/')+'pages/contact?finish=senza-gloss-white', location.origin)).href; link.textContent = 'Ask about Senza Gloss White'; notice.append(link);
      $('.ml-explore-copy').after(notice);
    }
    notice.hidden = !unavailable;
    $('[data-use-selection]').firstChild.textContent = unavailable ? 'Preview this finish ' : 'Plan this kitchen ';

    $$('[data-range]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.range === range)));
    const swatches = $('[data-kitchen-swatches]');
    if (swatches.dataset.activeRange !== range) {
      swatches.dataset.activeRange = range;
      swatches.replaceChildren(...selected.choices.map((item, index) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'ml-swatch'; button.style.setProperty('--colour', item[4]);
        button.dataset.finish = String(index); button.title = item[2]; button.setAttribute('aria-label', item[2]);
        return button;
      }));
    }
    $$('[data-finish]').forEach(button => button.setAttribute('aria-pressed', String(Number(button.dataset.finish) === finishIndex)));
  }
  function makeSurfaceButton(item) {
    const button = document.createElement('button');
    button.type = 'button'; button.className = 'ml-swatch'; button.dataset.surface = item.id;
    button.title = item.name; button.setAttribute('aria-label', item.name);
    const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.width = 40; img.height = 40; img.loading = 'lazy';
    button.append(img); return button;
  }
  function renderSurfaces() {
    perBrand[surface.brand] = surface;
    $$('[data-stone-image]').forEach(img => img.setAttribute('href', surface.image));
    $$('[data-surface-name]').forEach(el => el.textContent = surface.name);
    $$('[data-surface]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.surface === surface.id)));
    $$('[data-material-surfaces]').forEach(group => {
      const item = perBrand[group.dataset.materialSurfaces];
      const preview = group.closest('.ml-material');
      const photo = preview?.querySelector('[data-material-photo]');
      if (photo) { photo.src = item.image; photo.alt = item.name + ' slab photograph'; preview.querySelector('[data-material-caption]').textContent = item.name; }
    });
  }
  if (config.kind === 'kitchen') renderKitchen();
  else {
    $('[data-hero-surfaces]').replaceChildren(...['silestone-eternal-calacatta-gold', 'silestone-desert-silver', 'dekton-laurent', 'dekton-reverie'].map(id => config.surfaces.find(s => s.id === id)).filter(Boolean).map(makeSurfaceButton));
    $$('[data-material-surfaces]').forEach(group => group.replaceChildren(...config.surfaces.filter(s => s.brand === group.dataset.materialSurfaces).map(makeSurfaceButton)));
    renderSurfaces();
  }
  const requestId = () => typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
  function buildToolUrl(mode, shape, brand, request) {
    const url = keepPreview(new URL(config.root || '/', location.origin));
    url.searchParams.set('view', config.toolView);
    url.searchParams.set('example', mode === 'example' ? '1' : '0');
    if (config.kind === 'kitchen') {
      const choice = config.ranges[range].choices[finishIndex];
      url.searchParams.set('range', range); url.searchParams.set('finish', choice[0]); url.searchParams.set('colour', choice[1]);
      url.hash = 'planner';
    } else {
      const selected = brand && perBrand[brand] ? perBrand[brand] : surface;
      url.searchParams.set('surface', selected.id);
      if (shape) {url.searchParams.set('shape', shape);url.searchParams.set('piece_request', request || requestId());}
    }
    return url;
  }
  function updateLink(link, freshRequest = false) {
    if (link.dataset.shape && (freshRequest || !link.dataset.pieceRequest)) link.dataset.pieceRequest = requestId();
    link.href = buildToolUrl(link.dataset.mode || 'own', link.dataset.shape, link.dataset.brand, link.dataset.pieceRequest).href;
  }
  const updateLinks = () => $$('a[data-open-tool]').forEach(link => updateLink(link));
  updateLinks();
  root.addEventListener('click', event => {
    const link = event.target.closest('a[data-open-tool]');
    if (link && root.contains(link)) {
      updateLink(link, true);
      safeTrack('tool_open_requested', {mode:link.dataset.mode || 'own', selection:config.kind === 'kitchen' ? range : (link.dataset.brand ? perBrand[link.dataset.brand].id : surface.id)});
      return;
    }
    const button = event.target.closest('button');
    if (!button || !root.contains(button)) return;
    if (button.dataset.range || button.dataset.galleryRange) {
      range = button.dataset.range || button.dataset.galleryRange; finishIndex = 0; selectionVersion++; renderKitchen();
      if (button.dataset.galleryRange) $('#kitchen-looks').scrollIntoView({block:'start',behavior:'smooth'});
      safeTrack('style_selected', {range});
    }
    if (button.hasAttribute('data-finish')) {
      finishIndex = Number(button.dataset.finish); selectionVersion++; renderKitchen(); safeTrack('finish_selected', {range,finish:config.ranges[range].choices[finishIndex][2]});
    }
    if (button.dataset.surface) {
      surface = config.surfaces.find(s => s.id === button.dataset.surface) || surface; selectionVersion++; renderSurfaces(); safeTrack('surface_selected', {surface:surface.id});
    }
    updateLinks();
  });
  if ('IntersectionObserver' in window && $('.ml-hero')) new IntersectionObserver(entries => {$('#ml-sticky').hidden = entries[0].isIntersecting;}, {threshold:0}).observe($('.ml-hero'));
  safeTrack('landing_view');
  if (['own','example'].includes(params.get('start'))) {
    const shape = ['counter','island','side','entire-island'].includes(params.get('shape')) ? params.get('shape') : null;
    location.replace(buildToolUrl(params.get('start'), shape, null, params.get('piece_request')).href);
  }
})();
